<!-- COMPONENTE ABAS -->
<div class="card-header d-flex p-0 flex-column">
	<ul class="nav nav-tabs ml-auto p-0">
		<li class="nav-item">
			<a
				class="nav-link"
				[ngClass]="{ active: aba === 0 }"
				(click)="mudarAba(0)"
				>Informações Básicas
			</a>
		</li>
		<li class="nav-item">
			<a
				class="nav-link"
				[ngClass]="{ active: aba === 1 }"
				(click)="mudarAba(1)"
				>Cronograma
			</a>
		</li>
		<li class="nav-item">
			<a
				class="nav-link"
				[ngClass]="{ active: aba === 2 }"
				(click)="mudarAba(2)"
				>Custos e Recursos
			</a>
		</li>
		<li class="nav-item">
			<a
				class="nav-link"
				[ngClass]="{ active: aba === 3 }"
				(click)="mudarAba(3)"
				>Papéis
			</a>
		</li>
    <li class="nav-item">
			<a
				class="nav-link"
				[ngClass]="{ active: aba === 4 }"
				(click)="mudarAba(4)"
				>Solicitação Técnica
      </a>
		</li>
		<li class="nav-item">
			<a
				class="nav-link"
				[ngClass]="{ active: aba === 7 }"
				(click)="mudarAba(7)"
				>Folha Teste e PT
			</a>
		</li>
    <li class="nav-item">
      <a
        class="nav-link"
        [ngClass]="{ active: aba === 9 }"
        (click)="mudarAba(9)"
      >Matriz Constatação
      </a>
    </li>
    <li class="nav-item">
			<a
				class="nav-link"
				[ngClass]="{ active: aba === 8 }"
				(click)="mudarAba(8)"
				>Nota de Auditoria
			</a>
		</li>
	<li class="nav-item">
			<a
				class="nav-link"
				[ngClass]="{ active: aba === 5 }"
				(click)="mudarAba(5)"
				>Relatoria
			</a>
		</li>
	<li class="nav-item">
			<a
				class="nav-link"
				[ngClass]="{ active: aba === 6 }"
				(click)="mudarAba(6)"
				>Linha do tempo
			</a>
		</li>

	</ul>
</div>
<div>
	<!-- Aba Informações Básicas -->
	 <!--(modelChange)="receberModel($event)" -->
	<div #abaDados [hidden]="aba !== 0">
		<div>
			<app-osa-execucao-aba-informacoes-basicas
				 [visualizar]="visualizar" [model]="model"
			></app-osa-execucao-aba-informacoes-basicas>
		</div>
	</div>

	<!-- Aba Cronograma -->
	<div #abaDados [hidden]="aba !== 1">
		<div>
			<app-osa-execucao-aba-cronograma
				[visualizar]="visualizar"
				[id]="id"
			></app-osa-execucao-aba-cronograma>
		</div>
	</div>

	<!-- Aba Custos e Recursos -->
	<div #abaDados [hidden]="aba !== 2">
		<div>
			<app-osa-execucao-aba-custos-recursos
				[visualizar]="visualizar"
                [id]="id"
			></app-osa-execucao-aba-custos-recursos>
		</div>
	</div>

	<!-- Aba Papeis de Trabalho -->
	<div #abaDados [hidden]="aba !== 3">
		<div>
			<app-osa-execucao-aba-papeis
				[visualizar]="visualizar"
                [id]="id"
			></app-osa-execucao-aba-papeis>
		</div>
	</div>
  <div #abaDados [hidden]="aba !== 4">
		<div>
			<app-osa-execucao-aba-solicitacao-tecnica
				[visualizar]="visualizar"
                [id]="id"
			></app-osa-execucao-aba-solicitacao-tecnica>
		</div>
	</div>

	<!-- Aba Folha Teste -->
	<div #abaDados [hidden]="aba !== 7">
		<div>
			<app-osa-execucao-aba-folha-teste
				[visualizar]="visualizar"
                [id]="id"
				[model]="model"
			></app-osa-execucao-aba-folha-teste>
		</div>
	</div>
  <div #abaDados [hidden]="aba !== 8">
		<div>
			<app-osa-execucao-nota-auditoria
				[visualizar]="visualizar"
                [id]="id"
			></app-osa-execucao-nota-auditoria>
		</div>
	</div>
  <div #abaDados [hidden]="aba !== 9">
		<div>
			<app-osa-execucao-aba-matriz-constatacao
				[visualizar]="visualizar"
                [id]="id"
			></app-osa-execucao-aba-matriz-constatacao>
		</div>
	</div>

	<div #abaDados [hidden]="aba !== 5" class="p-4">
		<app-relatoria [aba]="aba" [relatoriaDados]="relatoriaDados" [model]="model"
                  [visualizar]="visualizar" [submit]="submit" [modelPagina]="model" [tipoTrabalhoId]="id">
		</app-relatoria>
	</div>

	<div #abaDados [hidden]="aba !== 6" class="p-4">
		<app-linha-do-tempo [aba]="aba"></app-linha-do-tempo>
	</div>

</div>
